<template>
    <modal @close="close" dialog="modal-wide" customClass="heightAuto" class="reservation-modal editReservationModal payment dark-top" :footer="false">
        <div slot="title" v-if="reservation">
            <h2 class="mb-1">{{headerLine1}}</h2>
            <h3 class="mb-1 light">{{headerLine2}}</h3>
        </div>

        <div slot="body" class="d-flex flex-column bg-lighter position-relative">
            <prebook-overlay v-if="showPrebookOverlay"></prebook-overlay>
            <div v-else>
                <create-invoice-modal :reservation="reservation" v-if="showCreateInvoiceModal" @close="toggleCreateInvoiceModal"></create-invoice-modal>
                <add-payment :reservation="reservation" :showAddPayment="showAddPayment" v-on:toggleAddPayment="toggleAddPayment" v-if="showAddPayment"></add-payment>
                <edit-extras :reservation="reservation" :showAddPayment="showAddPayment"  v-if="showEditExtras"></edit-extras>
                <add-extras :reservation="reservation"  v-if="showAddExtras"></add-extras>
                <edit-transport :reservation="reservation" :showAddPayment="showAddPayment" v-if="showEditTransport"></edit-transport>
                <invoice-modal v-if="showInvoiceModal" :reservation="reservation" @toggleInvoiceModal="toggleInvoiceModal"></invoice-modal>


                <div class="unsavedChanges bg-color-1 lightest text-center" :class="{'active':reservationHasUnsavedChanges}">
                😃 Hey there! Don't forget to <span class="bold">Save Changes</span>.
                </div>

                <div class="d-flex">
                    <div class="col-sm-10 text-center dark fs-larger p-5" v-if="!reservation">
                        Grab a coffe while we are loading ☕️
                    </div>
                    <div class="col-sm-10" v-else>
                        <top-area :disabled="getIsSavingReservation" :reservation="reservation" class="mt-3"></top-area>

                        <tabs class="tabsEditReservation">
                            <tab name="CUSTOMER DETAILS">
                                <tab-details :disabled="getIsSavingReservation" :reservation="reservation"></tab-details>
                            </tab>
                            <!-- <tab name="Extras">
                                <tab-extras :reservation="reservation"></tab-extras>
                            </tab> -->
                            <!-- <tab name="Pickups">
                                <tab-transport :reservation="reservation"></tab-transport>
                            </tab> -->
                            <tab name="BILLING">
                                <div class="col-sm-12 mt-2">

                                    <div class="col-sm-12 d-flex panel p-1 border-top-lightest border-left-lightest border-right-lightest justify-content-end" v-if="getShowInvoiceOption">
                                        <button :disabled="getIsSavingReservation" class="btn blue" @click="startCreateInvoice">Create Invoice</button>
                                    </div>

                                    <div v-if="reservation.bookingInvoices && reservation.bookingInvoices.length > 0" class="invoiceListHolder mb-3 panel p-0 border-top-lightest">
                                        <invoice-list :invoiceList="reservation.bookingInvoices" @toggleInvoiceModal="toggleInvoiceModal"></invoice-list>
                                    </div>

                                    <div v-else-if="getShowInvoiceOption" class="dark fs-large text-center m-5 mt-5">It seems you have no invoices.
                                    </div>
                                    <h3 class="mt-4 bold fs-normal">BILLING DETAILS</h3>
                                    <tab-billing-details :reservation="reservation" :readOnly="isReservationReadOnly || getIsSavingReservation" :showInvoiceBtn="false"></tab-billing-details>
                                </div>
                            </tab>
                            <!-- <tab name="Payment List">
                                <tab-payments :reservation="reservation"></tab-payments>
                            </tab> -->
                        </tabs>

                    </div>

                    <div class="col-sm-2 pl-0">
                        <side-buttons :disabled="getIsSavingReservation" :reservation="reservation" :showAddPayment="showAddPayment" v-on:toggleAddPayment="toggleAddPayment" @updateReservationsList="reservationUpdated"></side-buttons>
                        <!-- <button type="button" class="btn cancel wide" @click="cancel">Cancel</button>
                        <button type="button" class="btn ok wide" :disabled="disabled" @click="submit">Submit</button> -->
                    </div>
                </div>
            </div>

        </div>

        <div slot="footer" class="hidden">
        </div>
    </modal>
</template>

<script>
    import { reservationsMixin } from '@/mixins/reservations'

    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'

    import AddPayment from './ReservationEdit/AddPayment'
    import EditExtras from './ReservationEdit/EditExtras'
    import AddExtras from './ReservationEdit/AddExtras'
    import EditTransport from './ReservationEdit/EditTransport'
    import InvoiceModal from '@/tools/Invoice//InvoiceModal'
    import CreateInvoiceModal from '@/tools/Invoice/CreateInvoice'

    import InvoiceList from './ReservationEdit/TabBilling/InvoiceList'
    import SideButtons from './ReservationEdit/SideButtons'
    import TopArea from './ReservationEdit/TopArea'
    import TabDetails from './ReservationEdit/TabDetails'
    import TabExtras from './ReservationEdit/TabExtras'
    import TabTransport from './ReservationEdit/TabTransport'
    import TabPayments from './ReservationEdit/TabPayments'
    import TabBillingDetails from '../../components/reservations/NewReservation/Resume/Details/BillingDetails'

    import PrebookOverlay from './ReservationEdit/PrebookOverlay.vue'

    export default {
        data: function () {
            return {
                reservation: null,
                showAddPayment: false,
                showEditExtras: false,
                showAddExtras: false,
                showEditTransport: false,
                showInvoiceModal: false,
                showCreateInvoiceModal: false,
            }
        },
        created: function() {

            // if for some reason the reservation has no resource we set it to the first available on the event


            // this.getReservation()
            // if comes with the reservation there is no need to download it again, else download it
            /*if(typeof this.getSelectedReservation == 'object'){
                this.reservation = this.getSelectedReservation
                this.setReservationCalculations(this.reservation)
            } else {
                this.getReservation().then(r => {
                    this.setReservationCalculations(this.reservation)
                })
            }*/

            // downloads the reservation EVERYTIME
            // this.getReservation().then(r => {
            //     this.reservation = r.data
            //     this.setReservationCalculations(this.reservation)
            // })
                this.reservation = this.getSelectedReservation

                // something went worng
                if(!this.reservation.billing){
                    this.showSomethingWentWrongPopup(true)
                }

                this.setReservationCalculations(this.reservation)

                if(!this.reservation.selectedResource){
                    this.reservation.selectedResource = this.firstResourceWithAvailability()
                }

                if(!this.reservation.updateFlags){
                    this.$set(this.reservation, 'updateFlags', {})
                }

            //check if the event has mandatory extras and show them as a popup
            this.showMandatoryExtras(this.getSelectedReservation)

            // cleans calculationsGUID as this is a new reservation
            this.resetCalculationsGuid()

            // save the original status, if the status is changed only triggers warnings when pressing "save"
            this.saveOriginalStatus()

            // listener to toggle edit extras
            this.eventHub.$on('editReservation_toggleEditExtas', data => {
                this.showEditExtras = !this.showEditExtras
                if(data){
                    this.reservation.bookingComponents = data
                }
                this.setReservationCalculations(this.reservation)
            })

            // listener to open create invoice modal
            this.eventHub.$on('editReservation_toggleCreateInvoice', data => {
                this.toggleCreateInvoiceModal()
            })

            // listener to toggle add extras
            this.eventHub.$on('editReservation_toggleAddExtras', selectedSeller => {
                if(selectedSeller != 'close'){
                    // incremente "addExtras" to existing extras and requests calculations
                    if(this.showAddExtras){
                        this.reservation.event.eventComponents.map(eventExtra => {
                            var extra = JSON.parse(JSON.stringify(eventExtra))
                            extra.id = null
                            if(extra.quantityToAdd > 0){
                                extra.quantity = extra.quantityToAdd

                                if(selectedSeller.channelType){
                                    extra.channelType = selectedSeller.channelType
                                    extra.creatorUserAccount = null
                                    extra.creatorSupplier = null
                                    extra.creatorAgent = null
                                } else if(selectedSeller.userAccountTypeDefault || typeof selectedSeller.accessType == "number"){
                                    // console.log('My team');
                                    extra.creatorUserAccount = selectedSeller
                                    extra.creatorSupplier = selectedSeller.supplier
                                    extra.creatorAgent = null
                                } else {
                                    // console.log('Agent');
                                    extra.creatorUserAccount = null
                                    extra.creatorSupplier = null
                                    extra.creatorAgent = selectedSeller
                                }

                                console.log('selected Seller:', selectedSeller);

                                extra.commissionComponentValue = selectedSeller.commissionData? selectedSeller.commissionData.commissionComponentValue : 0;
                                extra.commissionComponentValueType = selectedSeller.commissionData? selectedSeller.commissionData.commissionComponentValueType: 0;
                                extra.creatorUserAccount = this.account // new key containing user

                                let addNewComponent = true
                                this.reservation.bookingComponents.map(bookingComponent => {
                                    if(bookingComponent.id == null && bookingComponent.componentPrice.id == extra.componentPrice.id){
                                        addNewComponent = false
                                        bookingComponent.quantity = extra.quantityToAdd
                                        bookingComponent.creatorUserAccount = extra.creatorUserAccount
                                        bookingComponent.creatorSupplier = extra.creatorSupplier
                                        bookingComponent.creatorAgent = extra.creatorAgent
                                    }
                                })

                                if(addNewComponent){
                                    this.reservation.bookingComponents.push(extra)
                                }

                            } else {
                                //when removing an added (unsaved) extra
                                this.reservation.bookingComponents.map(bookingComponent => {
                                    if(bookingComponent.id == null && bookingComponent.componentPrice.id == extra.componentPrice.id){
                                        bookingComponent.quantity = 0
                                    }
                                })
                            }

                            // extra.quantityToAdd = 0
                        })
                        this.setReservationCalculations(this.reservation)
                    }
                } else {
                    // Re adds selected to Availability
                    this.reservation.event.eventComponents.map(eventExtra => {
                        eventExtra.quantityAvailable += eventExtra.quantityToAdd
                        // eventExtra.quantityToAdd = 0

                    })

                }


                this.showAddExtras = !this.showAddExtras
            })

            // listener to toggle edit transport
            this.eventHub.$on('editReservation_toggleEditTransport', data => {
                this.showEditTransport = !this.showEditTransport
            })

            //set changeStatusTo key as null
            this.$set(this.reservation, 'changeStatusTo', null)

        },
        beforeDestroy() {
            this.eventHub.$off('editReservation_toggleEditExtas');
            this.eventHub.$off('editReservation_toggleAddExtras');
            this.eventHub.$off('editReservation_toggleCreateInvoice');
            // this.eventHub.$off('toggleInvoiceModal');
        },
        computed: {
            ...mapGetters([
                'account',
                'getSelectedReservation',
                'getCompanySettings',
                'getShowInvoiceOption',
                'getIsSavingReservation'
            ]),
            showPrebookOverlay: function () {
                return this.reservation && (this.reservation.status == 50 || this.reservation.status == -50)
            },
            disabled: function() {
                return false;
            },
            creatorName: function(){
                if(this.reservation.channelType >= 100 && this.reservation.channelType <= 102){
                    return 'Widget'
                }

                if(this.reservation.creatorUserAccount){
                    return this.reservation.creatorUserAccount.name
                } else {
                    return this.reservation.creatorAgent.brandName
                }
            },
            headerLine1: function(){
                return 'Booking Nº: ' + this.formatTicketNumber(this.reservation.id)
            },
            headerLine2: function(){
                return 'Booked by ' + this.reservation.createdByName + ' at ' + this.formatDateDots(this.reservation.reservationDate)+' '+this.formatTime(this.reservation.reservationDate)

            },
        },
        mixins:[
            reservationsMixin
        ],
        methods: {
            ...mapActions([
                'closeModal',
                'setReservationCalculations',
                'resetCalculationsGuid',
                'showSomethingWentWrongPopup'
            ]),
            cancel: function() {
                this.close();
            },
            close: function() {
                this.closeModal();
            },
            submit: function() {

            },
            getReservation: function() {
                return axios.get('/api/reservation/FindReservationBySupplier', {
                    params: {
                        supplierId: this.account.supplierId,
                        reservationId: this.getSelectedReservation.id
                    }
                }).then(response => {
                    return response
                    if(response.status == 200){
                        this.reservation = response.data
                        this.fixQuantityBooked();
                        //get agent commision
                        if(this.reservation.agent && this.reservation.agent.id){
                            this.getSelectedUserComissions()
                        }

                    }
                }).catch(error => {
                    return error
                })
            },
            toggleAddPayment: function(val) {
                //this.showAddPayment = (this.showAddPayment)? false : true;

                    this.showAddPayment = !this.showAddPayment;
            },
            toggleEditExtras: function(val) {
                    this.showEditExtras = !this.showEditExtras;
            },
            toggleAddExtras: function(val) {
                    this.showAddExtras = !this.showAddExtras;
            },
            toggleEditTranport: function(val) {
                    this.showEditTransport = !this.showEditTransport;
            },
            // Commented on 21/03/2018 - Unanecessary request, throws a error on basic account when loading a reservation made for an agent
            // getSelectedUserComissions: function(){
            //     axios.get('/api/people/GetAgentCommissions', {
            //         params: {
            //             supplierId: this.account.supplierId,
            //             agentId: this.reservation.creatorAgent.id
            //         }
            //     }).then(response => {
            //         if(response.status && response.status == 200){
            //             this.setAgentCommision(response.data)
            //             // this.$emit('agentComissionsChanged', response.data)
            //             // this.selectedAgentComissions = response.data;
            //         }
            //     })
            // },
            // setAgentCommision: function(commisions) {
            //     let agentCommision = commisions.defaultCommision
            //
            //     for(let commisionRelation of commisions.commissionRelations){
            //         if(commisionRelation.productId == this.reservation.event.product.id){
            //             agentCommision = commisionRelation.commissionValue;
            //         }
            //     }
            //
            //     this.$set(this.reservation.billing, 'agentCommision', agentCommision)
            // },
            fixQuantityBooked: function() {
                //when editing reservation the information on reservation.event.eventComponents[x] refers to the total sold of the event
                //so this fix set the reservation.event.eventComponents[x].quantityBooked to the same as in reservation.bookingComponents[x].quantity

                let vm = this

                // vm.reservation.bookingComponents.map(componentA => {
                for(var componentA of vm.reservation.bookingComponents){
                    vm.reservation.event.eventComponents.map(componentToFix => {
                        if(componentA.component.id == componentToFix.component.id){
                            componentToFix.quantityBooked = componentA.quantity
                            vm.$set(componentToFix, 'fixed', true)
                        }
                    })
                }

                // if there is any wrong quantity remaining (not fixed) will be set to zero
                vm.reservation.event.eventComponents.map(componentToFix => {
                    if(!componentToFix.fixed){
                        componentToFix.quantityBooked = 0
                    }
                })

            },
            saveOriginalStatus: function () {
                this.$set(this.reservation, 'originalStatus', this.reservation.status)
            },
            reservationUpdated: function (payload) {
                // this code is respnsible to update "not saved" booking components and reseting the "add extra" counters
                this.$set(this.reservation, 'bookingComponents', JSON.parse(JSON.stringify(payload.bookingComponents)))
                this.$set(this.reservation, 'bookingInvoices', JSON.parse(JSON.stringify(payload.bookingInvoices)))
                // this.reservation.bookingComponents = JSON.parse(JSON.stringify(payload.bookingComponents))

                this.reservation.event.eventComponents.map(eventComponent => {
                    // eventComponent.quantityToAdd = 0
                    this.$set(eventComponent, 'quantityToAdd', 0)
                })

                this.resetUpdateFlags()
            },
            resetUpdateFlags: function () {
                this.$set(this.reservation, 'updateFlags', {})
                // console.log('Update Flags reseted', this.reservation.updateFlags);
                // for (var key in this.reservation.updateFlags) {
                //    if (this.reservation.updateFlags.hasOwnProperty(key)) {
                //        this.reservation.updateFlags[key] = false
                //        // this.$set(this.reservation, key, false)
                //    }
                // }
            },
            toggleInvoiceModal: function () {
                this.showInvoiceModal = !this.showInvoiceModal
            },
            toggleCreateInvoiceModal: function (toggleTo) {
                if(!toggleTo){
                    this.showCreateInvoiceModal = !this.showCreateInvoiceModal
                } else {
                    this.showCreateInvoiceModal = toggleTo
                }
            },
            startCreateInvoice: function () {
                if(this.reservationHasUnsavedChanges){
                    this.$dialog.alert('There are unsaved changes, you must save the reservation before invoicing.', {okText: 'OK'})
                    .then(function () {

                    })
                    .catch(function () {
                    });

                    return false
                }

                this.eventHub.$emit('editReservation_toggleCreateInvoice')
                // this.createInvoice(this.reservation.id)
            }
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            SideButtons,
            TopArea,
            TabDetails,
            TabExtras,
            TabTransport,
            TabPayments,
            AddPayment,
            EditExtras,
            AddExtras,
            EditTransport,
            TabBillingDetails,
            InvoiceList,
            InvoiceModal,
            CreateInvoiceModal,
            PrebookOverlay
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .unsavedChanges{
        max-height: 0;
        padding: 0;
        transition: all ease-in-out 400ms;
        height: 0;
        overflow: hidden;

        &.active{
            max-height: none;
            padding: 0.25rem 0;
            height: 1.9rem;
        }
    }

    .tabs-component{
        min-height: 500px;
    }

    .tabs-component-panel{
        overflow: visible !important;
    }
</style>

<style lang="scss">
    /* hacky way to manipulate the look of the tabs */
    .tabsEditReservation{
        .tabs-component-tabs{
            margin-top: 0.5rem !important;
        }
        .tabs-component-tabs, .tabs-component-panels, .tabs-component-panel{
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
    }

    .invoiceListHolder{
        max-height: 340px;
        overflow: auto;
    }

</style>



// WEBPACK FOOTER //
// ReservationEdit.vue?23d16a7a